import { Component, OnInit } from '@angular/core';
import { GetLoginStylingService } from '@modules/api/get-login-styling.service.generated';
import { CurrentCaseService } from '@modules/common/services/current-case.service';

@Component({
    selector: 'app-login-layout-main-text',
    templateUrl: './login-layout-main-text.component.html',
    styleUrls: ['./login-layout-main-text.component.scss']
})
export class LoginLayoutMainTextComponent implements OnInit {
    public clientMainHTML: string | undefined;
    public loginStyleLoaded: boolean = false;
    public hasCurrentCase: boolean = false;

    constructor(
        private _getLoginStylingService: GetLoginStylingService,
        private readonly _currentCaseService: CurrentCaseService
    ) { }

    public ngOnInit(): void {
        this._getLoginStylingService.getLoginStyling().subscribe(result => {

            this.loginStyleLoaded = true;

            if (result) {
                this.clientMainHTML = result.mainHTML;
            }
        });

        this.hasCurrentCase = !!this._currentCaseService.getCurrentCaseName();
    }
}
